import * as app from "./scripts/app";
import * as Ajax from "./pwa/ajax";
import * as BucketTools from "./scripts/common/bucket";
import "./styles/acumulado.scss";
import * as Tercera from "./scripts/common/tercera";
import * as Utilities from "./scripts/common/utilities";
import * as Functions from "./scripts/common/functions";
import "./scripts/acumulado/functions.js";
import { revista, prioridadTag } from "../Settings/global/acumulado.json";
import * as LazyLoad from "./scripts/common/lazyload/lazyLoad";
import * as Sugerencias from './scripts/nota/sugerencias';
import { banner } from "../Settings/global.json";
import * as Banners from './scripts/common/banners';
import * as bomba from './scripts/common/bombaIntrasitio';
import * as Login from "./scripts/common/login";
import * as Logout from './scripts/common/logout';
import * as CustomDimension from  './scripts/common/analytics/CustomDimension';
import * as Session from  './scripts/common/session';
import * as Personalizacion from './scripts/common/personalizacion';
import pym from "./scripts/common/ext/pym.v1.min.js";

window.pym = pym;
window.LN = {};
window.LN.tipoPaginaBanner = "acumulado";
window.LN.configBanners = banner;
const meses = new Array("enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre");
const urlBucket = window.config.Statics.BucketUrl;
const urlAcuCategoriaSuplemento = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiCategoriaUrl;
const urlAcuTema = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoTemaUrl;
const urlAcuAutor = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoAutorUrl;
const urlAcuTagsRelacionados = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoTagsRelacionados;
const urlAcuImagenRelacionadas = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoImagenUrl;
const urlAcuUltimasNoticias = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiUltimasNoticias;
//*PÁGINADOS ACUMULADOS****************************************************************************************************************************************
const preObtenerMasNotas = () => {
    const cantNotasEnPagina = document.getElementsByClassName("nota").length;
    let cantNotasPaginado = 0;
    const verMas = document.getElementById("verMas");
    if (verMas) {
        cantNotasPaginado =  verMas.getAttribute("data-cantNotasPaginado");
        //let cantNotasEnPagina = 29;
        //console.log(cantNotasEnPagina, cantNotasPaginado, soloUnavez);
        if ((cantNotasEnPagina < cantNotasPaginado) ) { //&& soloUnavez
            verMas.style.display = "none";
            //soloUnavez = false;
        } else {
            verMas.style.display = "block";
            verMas.addEventListener("click", function() { obtenerMasNotas(this); });
        }  
    }
}

const obtenerMasNotas = (elementVerMas) => {
    //const elementVerMas = this;//.getElementById("verMas");
    if (elementVerMas == null) return false;
    const paginaSiguiente = document.getElementById("paginaSiguiente").value,
        tagId = elementVerMas.getAttribute("data-tagId"),
        autorId = elementVerMas.getAttribute("data-autorId"),
        sitioId = elementVerMas.getAttribute("data-sitioId"),
        cantNotasPaginado = elementVerMas.getAttribute("data-cantNotasPaginado"),
        esSuplemento = elementVerMas.getAttribute("data-esacusuplemento"),
        categoriaSuplementoId = elementVerMas.getAttribute("data-categoriasuplementoid");

    let url = "";

    if(esSuplemento == "True") url = urlAcuCategoriaSuplemento + categoriaSuplementoId + "?p=" + paginaSiguiente + "&c=" + cantNotasPaginado + "&origen=1";
    if (tagId > 0 && esSuplemento == "False") url = urlAcuTema + tagId + "?p=" + paginaSiguiente + "&c=" + cantNotasPaginado + "&s=" + sitioId;
    if (autorId > 0 && esSuplemento == "False") url = urlAcuAutor + autorId + "?p=" + paginaSiguiente + "&c=" + cantNotasPaginado + "&s=" + sitioId;
    //(tagId !== "") ? console.log("tag: " + url) : console.log("autor: " + url);
    if (tagId == 0 && autorId == 0 && esSuplemento == "False") {
        Ajax.get(urlAcuUltimasNoticias + "&c=" + cantNotasPaginado + "&p=" + paginaSiguiente + "&h=1")
            .then((result) => mostrarSiguientePagina(JSON.parse(result), cantNotasPaginado), () => console.log("Error durante el retorno de datos"));
    } else {
        Ajax.get(url)
            .then((result) => mostrarSiguientePagina(JSON.parse(result), cantNotasPaginado), () => console.log("Error durante el retorno de datos"));
    }
    
}

const mostrarSiguientePagina = (acuNotas) => {
    const notas = acuNotas.items,
        elementVerMas = document.getElementById("verMas"),
        paginaSiguiente = document.getElementById("paginaSiguiente").value,
        cantNotasPaginado = elementVerMas.getAttribute("data-cantNotasPaginado"),
        tagId = elementVerMas.getAttribute("data-tagId");
    //cantNotasPaginado = elementVerMas.getAttribute("data-cantNotasPaginado"),
    //Chequeo que la cantidad de notas actualmente desplegadas se mantenga dentro del valor máximo de notas, para evitar llamadas innecesarias.
    //TEST----> console.log((cantNotasPaginado * paginaSiguiente), acuNotas.acumuladoTotal);
    if ((cantNotasPaginado * paginaSiguiente) >= acuNotas.acumuladoTotal) 
        elementVerMas.style.display = "none";
       
    let html = "",
        imagenSrc;
    if (notas && notas.length > 0) {
        const breadCrumbTitulo = elementVerMas.getAttribute("data-breadcrumb");
        for (let nota of Array.from(notas)) {
            html += getArticleHtml(nota, breadCrumbTitulo, elementVerMas.getAttribute("data-tipoacu"), tagId);
        }
        //LazyLoad.implementLazyLoadImage();
    }
    //<div>
    //<span class="fecha"> 20 DE SEPTIEMBRE 2017</span>
    //<div class="redes-sociales">
    //<input type="hidden" id="hs-notaId" value="${nota.id}"/>
    //<input type="hidden" id="hs-titulo" value="${nota.titulo}"/>
    //<button id="facebookShare" class="icon-facebook" title="Compartir en Facebook"></button>
    //<button id="twitterShare" class="icon-twitter" title="Compartir en Twitter"></button>
    //</div>
    //</div>
    elementVerMas.insertAdjacentHTML('beforebegin', html);
    LazyLoad.implementLazyLoadImage();
    document.getElementById("paginaSiguiente").value = +paginaSiguiente + +1;
    //shareClickEvents();
}

const getArticleHtml = (nota, breadCrumbTitulo, acumuladoTipo, tagId) => {
    //let imagenSrc = (nota.imagenes !== undefined && nota.imagenes.length > 0)
    //    ? BucketTools.urlBucketBalance(urlBucket, setHeightImage(nota.imagenes[0].src))
    //    : "#";
    //la fecha puede venir [dd/MM/yyyy HH:mm:ss] o [yy-MM-dd HH:mm:ss] spliteamos por espacio y obtenemos la 1er parte que es la fecha
    let fecha = nota.fechaActualizacion.split(" ")[0];//(0, nota.fechaActualizacion.indexOf(" ")).split("-");
    let fechaFormateada = "";
    //el formatofinal ${fecha[2]} de ${meses[fecha[1] - 1]}  20${fecha[0]}
    //verificamos si tiene barra
    if (fecha.indexOf("/") != -1) {
        //dd/MM/yyyy
        fecha = fecha.split("/");
        fechaFormateada = fecha[0] + " de " + meses[fecha[1] - 1] + " de " + fecha[2];
    }//verificamos que tenga guiones
    else if (fecha.indexOf("-") != -1) {
        //yy-MM-dd
        fecha = fecha.split("-");
        fechaFormateada = fecha[2] + " de " + meses[fecha[1] - 1] + " de 20" + fecha[0];
    }


    let html = "";
    let isNotaAutor = false;
    let cssArticle = "";
    let revistas = revista;
    let notaTagDestacadoId = 0;
    if (nota.tagDestacado != null) {
        notaTagDestacadoId = nota.tagDestacado.id;
    }
    //Para mostrar el css de Revista el tagId de la acumulado tiene que ser distinto al tagId de la Revista
    let unaRevista = revistas.filter(r => r.CategoriaId == nota.categoriaId && r.TagId != tagId);
    let esBlack = false;
    if (nota.tags) {
        //Verificar si tiene algun tag de tipo = 14 Premiun contente Black
        let tagBlack = nota.tags.filter(t => t.tipoId == 14);
        if (tagBlack && tagBlack.length > 0) {
            cssArticle = "black";
        }
        
    }
    let cssRevista = "";
    let esAcuTagRevista = false;

    if (unaRevista != null && unaRevista.length > 0) {
        esAcuTagRevista = true;
        cssRevista = "revistas " + unaRevista[0].CssClass;
    }
    let imageUrl = "";
    let imageHtml = " ";
    switch(acumuladoTipo) {
        case "listadoAutor":
            cssArticle = cssArticle + isAnunciante(nota, breadCrumbTitulo);
            cssArticle = `nota ${cssArticle} ${cssRevista}`;
            
            html = `<article class="${cssArticle.trim()}">                      
                        <a class="figure" href="${nota.url}">`;
            
            if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                imageUrl = BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, 134);
                imageHtml = `<img src="${imageUrl}" alt="${nota.titulo.replace(/"/g, '')}"/>`;
            }
            html += imageHtml;
            html +=`</a>                        
                        <h2><a href="/${nota.url}">${nota.titulo}</a></h2>
                        ${getTagPrioridad(nota, breadCrumbTitulo, tagId, esAcuTagRevista, unaRevista, acumuladoTipo)}
                        <span class="fecha"> ${fechaFormateada}</span>                      
                    </article>`;
            return html;
        case "listado":
            isNotaAutor = nota.template_id == 3;//Opinion
            cssArticle = isNotaAutor ? "nota autor" : "nota " + cssArticle;
            cssArticle = cssArticle + isAnunciante(nota, breadCrumbTitulo) + cssRevista;
            cssArticle = cssArticle.trim();
            html = `<article class="${cssArticle}">`;
            if (!isNotaAutor)
            {
                if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                    imageUrl = BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, 134);
                    html += `<a class="figure" href="${nota.url}"><img src="${imageUrl}" alt="${nota.titulo.replace(/"/g, '')}"/></a>`;
                }
            }
            else
            {
                if (nota.autores instanceof Array && nota.autores.length > 0) {
                    let autor = nota.autores[0];
                    let imageAutorId = autor.hdImagenId;
                         
                    if (imageAutorId != null && imageAutorId != 0 && autor.ext != null && autor.ext != "") {
                        imageUrl = BucketTools.urlBucketBalance(urlBucket, imageAutorId, "81", "", autor.ext);
                        imageHtml = `<img src="${imageUrl}" alt="${autor.valor.replace(/"/g, '')}"/>`;
                    }
                    html += `<div><a class="figure">${imageHtml}</a>
                                <span><a href="/autor/${Utilities.FormatearUrl(autor.valor)}-${autor.id}">${autor.valor}</a></span></div>`;
                }
                    
            }
            html += `<h2><a href="${nota.url}">${nota.titulo}</a></h2>
                         ${getTagPrioridad(nota, breadCrumbTitulo, tagId, esAcuTagRevista, unaRevista, acumuladoTipo)}
                         <span class="fecha"> ${fechaFormateada}</span>                      
                         </article>`;
            return html;
        case "grilla":
            isNotaAutor = nota.template_id == 3;//Opinion
            cssArticle = isNotaAutor ? "nota autor" : "nota " + cssArticle + " " + cssRevista;
            cssArticle = cssArticle + isAnunciante(nota, breadCrumbTitulo);
            html = `<article class="${cssArticle}">`;
            if (!isNotaAutor)
            {
                if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                    imageUrl = BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, 180);
                    imageHtml = `<a class="figure" href="${nota.url}"><img src="${imageUrl}" alt="${nota.titulo.replace(/"/g,'')}"/></a>`;
                } else {
                    imageHtml = `<a class="figure" href="${nota.url}"></a>`;
                }


                html += `${imageHtml}
                         <div><h2><a href="${nota.url}">${nota.titulo}</a></h2>
                             ${getTagPrioridad(nota, breadCrumbTitulo, tagId, esAcuTagRevista, unaRevista, acumuladoTipo)}</div>`;
            }
            else {
                let autorNombreHtml = "";
                if (nota.autores instanceof Array && nota.autores.length > 0) {
                    let autor = nota.autores[0];
                    let imageAutorId = autor.hdImagenId;
                    if (imageAutorId != null && imageAutorId > 0 && autor.ext != null && autor.ext != "") {
                        imageUrl = BucketTools.urlBucketBalance(urlBucket, imageAutorId, "", 90, autor.ext);
                        imageHtml = `<img src="${imageUrl}" alt="${autor.valor.replace(/"/g, '')}"/>`;
                    }
                    autorNombreHtml = `<a class="nombre" href="${Utilities.formatoUrlAcuAutor(autor.valor,autor.id)}">${autor.valor}</a></div>`;
                }
                html += `<div>${getTagPrioridad(nota,breadCrumbTitulo,tagId,esAcuTagRevista,unaRevista,acumuladoTipo)}
                               <h2><a href="${nota.url}">${nota.titulo}</a></h2>
                            </div>
                            <div>
                            <figure>
                               ${imageHtml}
                            </figure>
                            ${autorNombreHtml}`;                
            }
            html += `</article>`;
            return html;
        case "ultimasNoticias":
            isNotaAutor = nota.template_id == 3;//Opinion
            cssArticle = isNotaAutor ? "nota autor" : "nota " + cssArticle ;
            cssArticle = cssArticle + isAnunciante(nota, breadCrumbTitulo) + cssRevista;
            cssArticle = cssArticle.trim();
            let tieneImagen = (nota.imagenes instanceof Array && nota.imagenes.length > 0);
            cssArticle = isNotaAutor ? cssArticle : (tieneImagen ? cssArticle + " foto" : cssArticle);
            const hora = nota.fechaActualizacion.split(":")[0].substr(nota.fechaActualizacion.split(":")[0].length - 2, 2) + ":" + nota.fechaActualizacion.split(":")[1];
            html = `<article class="${cssArticle}">
                    <div class="hora">${hora}</div>`;
            if (!isNotaAutor)
            {
                if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                    imageUrl = BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, 200);
                    html += `<a class="figure" href="${nota.url}"><img src="${imageUrl}" alt="${nota.titulo.replace(/"/g, '')}"/></a>`;   
                }
            }
            else
            {
                if (nota.autores instanceof Array && nota.autores.length > 0) {
                    let autor = nota.autores[0];
                    let imageAutorId = autor.hdImagenId;
                    if (imageAutorId != null && imageAutorId > 0 && autor.ext != null && autor.ext != "") {
                        imageUrl = BucketTools.urlBucketBalance(urlBucket, imageAutorId, 98, 101, autor.ext);
                        imageHtml = `<img src="${imageUrl}" alt="${autor.valor.replace(/"/g, '')}"/>`;
                    }
                    html += `<div><a class="figure">${imageHtml}</a>
                                <span><a href="/autor/${Utilities.FormatearUrl(autor.valor)}-${autor.id}">${autor.valor}</a></span></div>`;
                }
                    
            }
            html += `<h2><a href="${nota.url}">${nota.titulo}</a></h2>
                         ${getTagPrioridad(nota, breadCrumbTitulo, tagId, esAcuTagRevista, unaRevista, acumuladoTipo)}                    
                         </article>`;
            return html;
        case "listadoSuplemento":
            isNotaAutor = nota.template_id == 3;//Opinion
            cssArticle = isNotaAutor ? "nota autor" : "nota " + cssArticle ;
            cssArticle = cssArticle + isAnunciante(nota, breadCrumbTitulo) + cssRevista;
            cssArticle = cssArticle.trim();
            html = `<article class="${cssArticle}">`;
            if (!isNotaAutor)
            {
                if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                    imageUrl = BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, 134);
                    html += `<a class="figure" href="${nota.url}"><img src="${imageUrl}" alt="${nota.titulo.replace(/"/g, '')}"/></a>`;
                }
            }
            else
            {
                if (nota.autores instanceof Array && nota.autores.length > 0) {
                    let autor = nota.autores[0];
                    let imageAutorId = autor.hdImagenId;
                         
                    if (imageAutorId != null && imageAutorId > 0 && autor.ext != null && autor.ext != "") {
                        imageUrl = BucketTools.urlBucketBalance(urlBucket, imageAutorId, 98, 101, autor.ext);
                        imageHtml = `<img src="${imageUrl}" alt="${autor.valor.replace(/"/g, '')}"/>`;
                    }
                    html += `<div><a class="figure">${imageHtml}</a>
                                <span><a href="/autor/${Utilities.FormatearUrl(autor.valor)}-${autor.id}">${autor.valor}</a></span></div>`;
                }
                    
            }
            html += `<h2><a href="${nota.url}">${nota.titulo}</a></h2>
                         ${getTagPrioridad(nota, breadCrumbTitulo, tagId, esAcuTagRevista, unaRevista, acumuladoTipo)}
                         <span class="fecha"> ${fechaFormateada}</span>                      
                         </article>`;
            return html;
        case "grillaSuplemento":
            isNotaAutor = nota.template_id == 3;//Opinion
            cssArticle = isNotaAutor ? "nota autor" : "nota " + cssArticle + " " + cssRevista;
            cssArticle = cssArticle + isAnunciante(nota, breadCrumbTitulo);
            html = `<article class="${cssArticle}">`;
            if (!isNotaAutor)
            {
                if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                    imageUrl = BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, 180);
                    imageHtml = `<a class="figure" href="${nota.url}"><img src="${imageUrl}" alt="${nota.titulo.replace(/"/g, '')}"/></a>`;
                }
                html += `${imageHtml}
                         <div><h2><a href="${nota.url}">${nota.titulo}</a></h2>
                             ${getTagPrioridad(nota, breadCrumbTitulo, tagId, esAcuTagRevista, unaRevista, acumuladoTipo)}</div>`;
            }
            else
            {
                if (nota.autores instanceof Array && nota.autores.length > 0) {
                    let autor = nota.autores[0];
                    let imageAutorId = autor.hdImagenId;
                    if (imageAutorId != null && imageAutorId > 0 && autor.ext != null && autor.ext != "") {
                        imageUrl = BucketTools.urlBucketBalance(urlBucket, imageAutorId, "", 90, autor.ext);
                        imageHtml = `<img src="${imageUrl}" alt="${autor.valor.replace(/"/g, '')}"/>`;
                    }
                    html += `<div>${getTagPrioridad(nota, breadCrumbTitulo, tagId, esAcuTagRevista, unaRevista, acumuladoTipo)}
                               <h2><a href="${nota.url}">${nota.titulo}</a></h2>
                            </div>
                            <div>
                            <figure>
                               ${imageHtml}
                            </figure>
                            <a class="nombre" href="/autor/${Utilities.FormatearUrl(autor.valor)}-${autor.id}">${autor.valor}</a></div>`;
                }
                
            }
            html += `</article>`;
            return html;
    }
    
    return html;
}
    
const getTagDescripcionFromTagTipo = (tipoId, tagDescripcion) => {
    let desc = "";
    if(tipoId === 9 || tipoId === 10){
        desc = (tipoId === 9) ? "ESPACIO PATROCINADO" : "CONTENT LAB PARA " + tagDescripcion;
    } else {
        desc = tagDescripcion;
    }
    return desc;
}

const setHeightImage = (urlImage) => {
    const ext = urlImage.slice(-4);
    const image = urlImage.slice(0, urlImage.length - 4);
    return image + "h236" + ext;
}

const isAnunciante = (nota, breadCrumbTitulo) => {
    let tipoId = nota.tagDestacado.tipoId;
   
    if(tipoId !== 9 && tipoId !== 10 || nota.tagDestacado.valor === breadCrumbTitulo) return "";
    let desc = (tipoId === 9) 
        ? " espacio-patrocinado" 
        : " content-lab";
    return desc;
}

//Solo chequea que sean ContentLab o Espacio Patrocinado.
const getTagPrioridad = (nota, breadCrumbTitulo, tagIgnorar, esRevista, revistaTag, acuTipo) => {
    const esAutor = nota.template_id == 3;//Opinion
    const esGrilla = acuTipo == "grilla";
    let cssTema = ``;
    if (esAutor && esGrilla) {
        cssTema = `class="tema"`
    }
    const prioridaTagConfigList = prioridadTag;
    let html = "",
        tipoId = nota.tagDestacado.tipoId;
    if (nota.tagDestacado.valor == null || nota.tagDestacado.valor == "undefined") {
        return html;
    }
    //if(nota.tagDestacado.valor === breadCrumbTitulo) return html;
    let desc = getTagDescripcionFromTagTipo(tipoId, nota.tagDestacado.valor);

    if (esRevista) {
        html = `<h3><a ${cssTema} href="/${Utilities.FormatearUrl(revistaTag[0].TagNombre)}-t${revistaTag[0].TagId}"></a></h3>`;
    }
    else if (nota.tagDestacado.id != tagIgnorar) {
        html = `<h3><a ${cssTema} href="/${Utilities.FormatearUrl(nota.tagDestacado.valor)}-t${nota.tagDestacado.id}">${desc}</a></h3>`;
    }//obtenemos el 2do tag prioritario si el tag destacado es igual al tag del Acumulado
    else if (nota.tags != null && nota.tags.length > 0) {
        let _notaTags = nota.tags.filter(t => t.formatoId != 2 && t.id != tagIgnorar);
        _notaTags = _notaTags.sort((a,b) => {
            //return 0;
            return (a.prioridad > b.prioridad) ? 1 : ((b.prioridad > a.prioridad) ? -1 : 0);
        });
        for (var i = 0; i < _notaTags.length; i++) {
            let segundotagPrioritario = prioridaTagConfigList.filter(tagPrio => tagPrio.tagtipo == _notaTags[i].tipoId);           
            if (segundotagPrioritario != null && segundotagPrioritario.length > 0) {                
                desc = getTagDescripcionFromTagTipo(_notaTags[i].tipoId, _notaTags[i].valor);
                html = `<h3><a ${cssTema} href="/${Utilities.FormatearUrl(_notaTags[i].valor)}-t${_notaTags[i].id}">${desc}</a></h3>`;
                return html;
            }

        }
        
    }     
    return html;
}

const renderTemasRelacionados = (data, tagId) => {

    const container = document.getElementById("temasRelacionados");
    if (!!container) {
        const cantMaxMostrar = 4;
        let temaRelaHtml = `<div class="techo floatFix"><h4>Temas <b>Relacionados</b></h4></div>`;
        let tags = data.tags;
        
        if (tags != null && tags.length > 0) {
            //Se quitan lo tags ocultos y los de tipo persona
        
            tags = tags.filter(t => t.formatoId != 2 && t.tipoId != 2 && t.id != tagId);
            
            if (tags.length > 0) {
                tags = tags.sort((a, b) => {
                    //return 0;
                    return (a.cantidad < b.cantidad) ? 1 : ((b.cantidad < a.cantidad) ? -1 : 0);
                });
                for (let i = 0; i < tags.length && i < cantMaxMostrar; i++) {
                    const tag = tags[i];
                    let tagDescripcion = tag.descripcion;
                    if (tag.tipoId == 10) {
                        tagDescripcion = "CONTENT LAB PARA " + tagDescripcion;
                    }

                    temaRelaHtml += `<a href="${Utilities.formatoUrlAcuTag(tag.descripcion, tag.id)}">${tagDescripcion}</a>`; 
                }
        
                container.innerHTML = temaRelaHtml;
                //app.interceptLinks(container);
            }  
            else {
                /*Produto reporto que si no vienen tags (temas) relacionado no se dibuje el aside vacio
                  por lo tanto se quita del DOM*/
                container.parentNode.removeChild(container);
            }
        } else {
            /*Produto reporto que si no vienen tags (temas) relacionado no se dibuje el aside vacio
              por lo tanto se quita del DOM*/
            container.parentNode.removeChild(container);
        }
    }   
}

const renderPersonasRelacionadas = (data, tagId) => {
    
    const container = document.getElementById("personasRelacionadas");
    if (!!container) {
        const cantMaxMostrar = 3;
        let temaRelaHtml = `<div class="techo floatFix"><h4>Personas <b>Relacionadas</b></h4></div>`;
        let tags = data.tags;

        if (tags != null && tags.length > 0) {

            //Se quitan lo tags ocultos y se filtra solo por los de tipo persona
            tags = tags.filter(t => t.formatoId != 2 && t.tipoId == 2 && t.id != tagId);
            
            if (tags.length > 0) {
                tags = tags.sort((a, b) => {
                    //return 0;
                    return (a.cantidad < b.cantidad) ? 1 : ((b.cantidad < a.cantidad) ? -1 : 0);
                });
                for (let i = 0; i < tags.length && i < cantMaxMostrar; i++) {
                    const tag = tags[i];
                    let imagenUrl = "";
                    let imagenHtml = "";
                    if (tag.imagen != null && tag.imagen.src != null && tag.imagen.src != "") {
                        imagenUrl = BucketTools.urlBucketBalance(urlBucket, tag.imagen.src, "81", "");
                        imagenHtml = `<img src="${imagenUrl}" />`;
                    }
                    temaRelaHtml += `<a href="${Utilities.formatoUrlAcuTag(tag.descripcion, tag.id)}">
                                        <div>
                                            ${imagenHtml}
                                        </div>
                                        <span>${tag.descripcion}</span>
                                     </a>`; 
                }
        
                container.innerHTML = temaRelaHtml;

            }
            else {
                /*Produto reporto que si no vienen tags (temas) relacionado no se dibuje el aside vacio
                  por lo tanto se quita del DOM*/
                container.parentNode.removeChild(container);
            }
        
        }
        else {
            /*Produto reporto que si no vienen tags (temas) relacionado no se dibuje el aside vacio
              por lo tanto se quita del DOM*/
            container.parentNode.removeChild(container);
        }
    }
}
const renderTemas = (data, tagId) => {

    renderPersonasRelacionadas(data,tagId);
    renderTemasRelacionados(data, tagId);

}

const renderFotosDe = (data, tagId) => {
    
    const container = document.getElementById("acumuladoFotosDe");
    if (!!container) {
        const imagenesRelacionadas = data.items;
        if (imagenesRelacionadas != null && imagenesRelacionadas.length > 0) {
            let cantidadMax = 6;
            let tagAcu = document.querySelector("main[data-Acu-Descripcion]");
            let tagDescripcion = "";
            if (tagAcu) {
                tagDescripcion = tagAcu.getAttribute("data-Acu-Descripcion");
            }
        
            let htmlFotosDe = `<div class="techo floatFix">
                                <h4><a href="${Utilities.formatoUrlAcuFotoTag(tagDescripcion, tagId)}">Fotos de <b>${tagDescripcion}</b></a></h4>
                              </div>`;
            let imageUrl = "";
            let imageHtml = "";
            for (let i = 0; i < imagenesRelacionadas.length && i < cantidadMax; i++) {
               
                let imagenHref = Utilities.formatoUrlAcuFotoTag(tagDescripcion, tagId);
                let imagenId = "";
                if (imagenesRelacionadas[i].src != null && imagenesRelacionadas[i].src != "") {
                    imagenId = imagenesRelacionadas[i].src.split("/")[4].split(".")[0];//Cambiaron el tipo de barras en el path de la imagen antes era \ y ahora son /
                    imageUrl = BucketTools.urlBucketBalance(urlBucket, imagenesRelacionadas[i].src, "98", "148");
                    imagenHref += "#" + imagenId;
                    imageHtml = `<img src="${imageUrl}" />`;
                }

                htmlFotosDe += `<a class="figure" href="${imagenHref}">
                                    ${imageHtml}
                                </a>`;          
            }

            htmlFotosDe += `<a class="ver-todas" href="${Utilities.formatoUrlAcuFotoTag(tagDescripcion, tagId)}"> VER TODAS LAS FOTOS <span class="icon-ir"></span></a>`;

            container.innerHTML = htmlFotosDe;
            
        }
        
    }

}
const obtenerTemasRelacionados = () => {
    let tag = document.querySelector("main[data-Acu-TagId]");
    if (tag) {
        let tagId = tag.getAttribute("data-Acu-TagId");

        Ajax.get(urlAcuTagsRelacionados + tagId)
            .then((rs) => renderTemas(JSON.parse(rs), tagId), 
            () => console.log("obtenerTemasRelacionados Error durante el retorno de datos"));
    }
}

const obtenerImagenesRelacionadas = () => {
    
    let tag = document.querySelector("main[data-Acu-TagId]");
    if (tag) {
        let tagId = tag.getAttribute("data-Acu-TagId");

        Ajax.get(urlAcuImagenRelacionadas + tagId)
            .then((rs) => renderFotosDe(JSON.parse(rs), tagId), 
                () => console.log("obtenerImagenesRelacionadas Error durante el retorno de datos"));
    }
}

const styles = () => {
    $(".leer-mas").click(function(){ $(this).parent().parent().toggleClass("expandido");});
    $(".mas-info").click(function() { $(this).parent().toggleClass("mostrar-info"); });
}

const LinksFooter = () => {
    if (document.querySelector("#pie-facebook")) {
        document.querySelector("#pie-facebook").addEventListener("click", function() { window.open("https://www.facebook.com/lanacion", "_blank") });
    }

    if(document.querySelector("#pie-twitter"))
        document.querySelector("#pie-twitter").addEventListener("click", function() { window.open("https://twitter.com/LANACION", "_blank") });
    
    if(document.querySelector("#pie-instagram"))
        document.querySelector("#pie-instagram").addEventListener("click", function() { window.open("https://www.instagram.com/lanacioncom/", "_blank") });
    
    if(document.querySelector("#pie-rss"))
        document.querySelector("#pie-rss").addEventListener("click", function() { window.open("http://servicios.lanacion.com.ar/herramientas/rss/ayuda", "_blank") });
    
    if(document.querySelector("#pie-apple"))
        document.querySelector("#pie-apple").addEventListener("click", function() { window.open("https://www.google.com.ar/url?sa=t&rct=j&q=&esrc=s&source=web&cd=1&cad=rja&uact=8&ved=0ahUKEwjsqvOLkr7XAhUDjpAKHZyiBigQFgglMAA&url=https%3A%2F%2Fitunes.apple.com%2Far%2Fapp%2Fla-nacion%2Fid410689702%3Fmt%3D8&usg=AOvVaw3LqfU_ag8u27BMNAtmRxqN", "_blank") });
    
    if(document.querySelector("#pie-android"))
        document.querySelector("#pie-android").addEventListener("click", function() { window.open("https://play.google.com/store/apps/details?id=app.lanacion.activity&hl=es_419", "_blank") });

}

const validarSession = () => { 
    if (Session.init()) {
        Personalizacion.preferenciasPendientes();
        Personalizacion.registrarAccesosAcumulados();
    }
}


const initIframePym = () => {
    $("iframe.pym").each(function (i, nodo) {
        var id = $(nodo).data('id') || ('pymnro' + i),
            url = $(nodo).attr('src') || $(nodo).data('src'),
            opts = /*$(nodo).data('opts') || HAY QUE PARSEAR JSON*/ {};

        if (!!url) {
            $(nodo).after('<div id="' + id + '"></div>');
            $(nodo).remove();

            var mypym = new pym.Parent(id, url, opts);
            mypym.onMessage('pymEspecialesLoaded', function (status) {
                if (status === 'ready')
                    mypym.sendMessage('setShareUrl', document.URL);
            });
        }
    });
}

const initialize = () => { 
    validarSession();
    Banners.loadBanners(window.LN.tipoPaginaBanner);    
    Tercera.getCotizacionDivisas();
    Personalizacion.seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
    Personalizacion.preferenciasCambioBotonSiguiendo();
    styles();
    preObtenerMasNotas();
    obtenerTemasRelacionados();
    obtenerImagenesRelacionadas();
    Tercera.getRanking();
    Tercera.getPromoContentLab();
    Tercera.getPromoClubLn();
    Sugerencias.getNewsletter();
    LazyLoad.implementLazyLoadImage();
    bomba.checkBomba();
    Login.Initialize();
    Logout.Initialize();
    Functions.buscador();
    CustomDimension.MakeCustomDimension();
    LinksFooter();
    initIframePym();
}
app.start().then(initialize);


// WEBPACK FOOTER //
// ./Statics/acumulado.js